import * as t from "io-ts";
import { IntroductionStats } from "./IntroductionStats";

export const InfoIntroductionStats = t.type({
  report: t.record(t.string, IntroductionStats),
});

export interface InfoIntroductionStats {
  report: Record<string, IntroductionStats>;
}
